<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <i class="material-icons cusIconSize">&#xE8B4;</i>
          <span>Manage Country</span>
        </p>
      </div>
      <div class="admBreadcumTitle">
        <p class="admManageExamBreadcumCls">
          <span>
            <a [showUnSavedChangesAlert]="{ form: form, redirect: 'AdmManageCountry'}" class="searchFormLink">Manage Countries</a>
            &gt;
            <span class="addEditFormLink">{{title}}</span>
          </span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p><span>{{title}}</span></p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <form class="example-form" novalidate [formGroup]="form">
            <div class="col s12 m4 l4">
              <div class="errorZoneSec">
                <md-select placeholder="Exclude Exam Types" formControlName="unsupportedExamTypes" class="triggerMenuDiv" multiple>
                  <md-option *ngFor="let option of unsuportableExamTypes" [value]="option.examType" class="subOptionShow">
                    <span>{{ option.name }}</span>
                  </md-option>
                </md-select>
              </div>
            </div>
          </form>
        </md-card-content>
        <div class="col s12 m12 l12">
          <md-card-actions>
            <div class="button-row">
              <button [disabled]="isSaveBtnDisable" md-raised-button class="glbAdminBtnCls1" type="submit" (click)="saveCountry()">SAVE</button>
              <button [disabled]="isEditBtnDisable" md-raised-button class="glbAdminBtnCls1" (click)="editCountry()">EDIT</button>
            </div>
          </md-card-actions>
        </div>
      </md-card>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-country/adm-update-country/adm-update-country.component.html